import { render } from "./InvoiceGenerateVoucher.vue?vue&type=template&id=513ffcb5&scoped=true"
import script from "./InvoiceGenerateVoucher.vue?vue&type=script&lang=js"
export * from "./InvoiceGenerateVoucher.vue?vue&type=script&lang=js"

import "./InvoiceGenerateVoucher.vue?vue&type=style&index=0&id=513ffcb5&scoped=true&lang=css"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513ffcb5"]])

export default __exports__